module.exports = __webpack_public_path__ + "img/handClick.cbe255a3.png";